// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"PrivacyPolicy_privacyPolicy__b_esq"};